import { Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { buttonColors, colors } from "../../utility/types/constant";

interface AddMemberBtnProps {
  onClick: () => void;
}

const AddMemberBtn = (props: AddMemberBtnProps) => {
  const { onClick } = props;

  return (
    <Button
      onClick={onClick}
      variant="outlined"
      startIcon={<AddIcon />}
      sx={{
        borderColor: buttonColors.mainPrimary,
        color: colors.mainPrimary,
      }}
    >
      <Typography
        variant="subtitle2"
        sx={{
          color: colors.darkGrey,
        }}
      >
        Member
      </Typography>
    </Button>
  );
};

export default AddMemberBtn;
